import { GeckoEntryBase } from 'types/entries/geckoEntry'
import { Branded } from 'types/generics/brand'
import { RolodexEntryType } from 'types/rolodex/rolodexEntries'

export type ExtensionId = Branded<string, 'ExtensionId'>

/**
 * Used to assert that an id is an extension id
 */
export function assertIsExtensionId(id: string): ExtensionId {
  if (!/^[A-Z][a-z0-9]*([A-Z][a-z0-9]*)*$/.test(id)) {
    throw new Error(`Invalid extension id: ${id}`)
  }
  return id as ExtensionId
}

export type ResourceId = Branded<string, 'ResourceId'>

export type ExtensionConfig = {
  extension_id: ExtensionId
  enabled?: boolean
  required_permissions?: string[]
  override_title?: string
}

export type ExtensionConfigEntry = GeckoEntryBase<
  ExtensionConfig,
  { organization: string }
>

export type ExtensionConfigPutEntry = Pick<
  ExtensionConfigEntry,
  'id' | 'data' | 'tags' | 'type'
>

export type ResourceExtensionConfig = {
  resourceId: ResourceId
  resourceName: string
  resourceType: RolodexEntryType
  isEnabled: boolean
  isCustomerVisible: boolean
  config: ExtensionConfigPutEntry
}
